<template>
	<div class="app-loader">
		<div class="preloader-wrapper active">
	    <div class="spinner-layer" :class="color" >
	      <div class="circle-clipper left">
	        <div class="circle"></div>
	      </div><div class="gap-patch">
	        <div class="circle"></div>
	      </div><div class="circle-clipper right">
	        <div class="circle"></div>
	      </div>
	    </div>
	  </div>	
	</div>
</template>
<script>
	//этот комп будет регист глобально чтобы был доступен везде
	//будет импорт в файле мейн
	 export default{
	 	computed:{
	 		//здесь будут храниться классы для лоудера
	 		color(){
	 			const colors = ['spinner-red-only', 'spinner-blue-only', 'spinner-green-only' ]
	 			return colors[Math.floor(Math.random()*3)]
	 		}

	 	}

	 	}
</script>